import { TableCell } from "@material-ui/core";
import { memo } from "react";

const AccountTableCell = ({ align, id, data, maxWidth, minWidth, style }) => (
  <TableCell
    align={align}
    key={id}
    style={{
      fontSize: "0.75rem",
      maxWidth,
      minWidth,
      overflow: "hidden",
    }}
  >
    <div style={style}>{data}</div>
  </TableCell>
);
export default memo(AccountTableCell);
